export enum ListUsersType {
  PendingUsers = 'pendingUsers',
  ActiveUsers = 'activeUsers',
}
